// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PremiumPaymentMutationMutationVariables = Types.Exact<{
  updateEntityInput: Types.AugmentedUpdateEntityInput;
  taskId: Types.Scalars['ID']['input'];
}>;


export type PremiumPaymentMutationMutation = { __typename?: 'Mutation', updateEntity: { __typename?: 'Entity', id: string }, completeEntityTask: { __typename?: 'EntityTask', id: string } };

export const Operations = {
  Mutation: {
    PremiumPaymentMutation: 'PremiumPaymentMutation' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const PremiumPaymentMutationDocument = gql`
    mutation PremiumPaymentMutation($updateEntityInput: AugmentedUpdateEntityInput!, $taskId: ID!) {
  updateEntity(input: $updateEntityInput) {
    id
  }
  completeEntityTask(id: $taskId) {
    id
  }
}
    `;
export type PremiumPaymentMutationMutationFn = Apollo.MutationFunction<PremiumPaymentMutationMutation, PremiumPaymentMutationMutationVariables>;

/**
 * __usePremiumPaymentMutationMutation__
 *
 * To run a mutation, you first call `usePremiumPaymentMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePremiumPaymentMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [premiumPaymentMutationMutation, { data, loading, error }] = usePremiumPaymentMutationMutation({
 *   variables: {
 *      updateEntityInput: // value for 'updateEntityInput'
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function usePremiumPaymentMutationMutation(baseOptions?: Apollo.MutationHookOptions<PremiumPaymentMutationMutation, PremiumPaymentMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PremiumPaymentMutationMutation, PremiumPaymentMutationMutationVariables>(PremiumPaymentMutationDocument, options);
      }
export type PremiumPaymentMutationMutationHookResult = ReturnType<typeof usePremiumPaymentMutationMutation>;
export type PremiumPaymentMutationMutationResult = Apollo.MutationResult<PremiumPaymentMutationMutation>;
export type PremiumPaymentMutationMutationOptions = Apollo.BaseMutationOptions<PremiumPaymentMutationMutation, PremiumPaymentMutationMutationVariables>;